import * as React from "react";
import {useGlobalContext} from "../../../services/context.service";
import InnerContainer from "../../Common/InnerContainer";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import {fnLocalizeFilter} from "../../../services/localize.service";
import TabPanel from "@mui/lab/TabPanel";
import {Grid} from "@mui/material";
import {TabContext} from "@mui/lab";
import Billing from "./Billing/Billing";
import CertificatesOfWorkPerformed from "./CertificatesOfWorkPerformed/CertificatesOfWorkPerformed";
import {getConfigFromFile} from "../../../utils/methods";
import {useEffect, useState} from "react";

const certificatesOfWorkPerformed = {
    isActive: true
};


export default function Documents() {
    const {locale} = useGlobalContext();
    const [selectedTab, setTab] = React.useState('1');

    const [isShowCertificatesOfWorkPerformed, setShowCertificatesOfWorkPerformed] = useState<boolean>(false);

    useEffect(() => {
        getConfigFromFile().then(setting => {
            setShowCertificatesOfWorkPerformed(setting.config.certificatesOfWorkPerformed)
        });

    }, []);

    const handleChangeTab = (event: React.SyntheticEvent, newTab: string) => {
        setTab(newTab);
    };

    return <>
        <InnerContainer direction={'left'} show={true}>
            <Grid item xs={2}>
                <TabContext value={selectedTab}>
                    <TabList onChange={handleChangeTab} aria-label="lab API tabs example">
                        <Tab label={fnLocalizeFilter(locale, '_lang.module.documents.billing.titleTab')} value="1"/>
                        {isShowCertificatesOfWorkPerformed &&
                            <Tab label={fnLocalizeFilter(locale, '_lang.module.documents.certificates.titleTab')}
                                 value="2"/>}
                    </TabList>
                    <TabPanel value="1">
                        <Billing/>
                    </TabPanel>
                    <TabPanel value="2">
                        <CertificatesOfWorkPerformed/>
                    </TabPanel>
                </TabContext>
            </Grid>
        </InnerContainer>
    </>
}
